module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "colForm",
    staticClass: "demo-dynamic",
    attrs: {
      "model": _vm.col,
      "rules": _vm.rules,
      "label-width": "90px"
    }
  }, [(!_vm.isSimple) ? _c('el-form-item', {
    attrs: {
      "label": "列宽度"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.width),
      expression: "col.width"
    }],
    staticClass: "w-200",
    attrs: {
      "type": "number",
      "max": "12"
    },
    domProps: {
      "value": (_vm.col.width)
    },
    on: {
      "blur": [function($event) {
        _vm.checkColWidth(_vm.col)
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        _vm.col.width = _vm._n($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tips"
  }, [_vm._v("填n代表占表格宽度的n/12，最大可填12")])]) : _vm._e(), _vm._v(" "), (!_vm.isSimple) ? _c('el-form-item', {
    attrs: {
      "label": "分组名称"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.col.group_name),
      expression: "col.group_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "w-200",
    domProps: {
      "value": (_vm.col.group_name)
    },
    on: {
      "input": function($event) {
        _vm.col.group_name = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isSimple) ? _c('el-form-item', {
    attrs: {
      "label": "排序筛选开启"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.is_sort),
      expression: "col.is_sort"
    }],
    domProps: {
      "value": (_vm.col.is_sort)
    },
    on: {
      "input": function($event) {
        _vm.col.is_sort = $event
      }
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "显示内容"
    }
  }, [_c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.is_exit),
      expression: "col.is_exit"
    }],
    staticClass: "radio",
    attrs: {
      "label": 1
    },
    domProps: {
      "value": (_vm.col.is_exit)
    },
    on: {
      "input": function($event) {
        _vm.col.is_exit = $event
      }
    }
  }, [_vm._v("数据表字段")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.is_summary),
      expression: "col.is_summary"
    }],
    staticClass: "radio",
    attrs: {
      "label": 1
    },
    domProps: {
      "value": (_vm.col.is_summary)
    },
    on: {
      "input": function($event) {
        _vm.col.is_summary = $event
      }
    }
  }, [_vm._v("汇总")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.is_statistics),
      expression: "col.is_statistics"
    }],
    staticClass: "radio",
    attrs: {
      "label": 1
    },
    domProps: {
      "value": (_vm.col.is_statistics)
    },
    on: {
      "input": function($event) {
        _vm.col.is_statistics = $event
      }
    }
  }, [_vm._v("统计运算")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.is_php),
      expression: "col.is_php"
    }],
    staticClass: "radio",
    attrs: {
      "label": 1
    },
    domProps: {
      "value": (_vm.col.is_php)
    },
    on: {
      "input": function($event) {
        _vm.col.is_php = $event
      }
    }
  }, [_vm._v("PHP语句")])]), _vm._v(" "), _vm._v(" "), (_vm.fieldSelect) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "选择字段",
      "prop": "field_id"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.field_id),
      expression: "col.field_id"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "请选择字段"
    },
    domProps: {
      "value": (_vm.col.field_id)
    },
    on: {
      "change": _vm.changeField,
      "input": function($event) {
        _vm.col.field_id = $event
      }
    }
  }, _vm._l((_vm.filedOptions), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.field + item.title,
        "value": item.field_id
      }
    }, [_c('span', [_vm._v(_vm._s(item.field) + "（" + _vm._s(item.title) + "）")])])
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "显示名",
      "prop": "show_name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.show_name),
      expression: "col.show_name"
    }],
    staticClass: "w-200",
    domProps: {
      "value": (_vm.col.show_name)
    },
    on: {
      "input": function($event) {
        _vm.col.show_name = $event
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), (_vm.isSummary) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "关联表"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.summaryConfig.table_id),
      expression: "col.summaryConfig.table_id"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "请选择关联表"
    },
    domProps: {
      "value": (_vm.col.summaryConfig.table_id)
    },
    on: {
      "change": _vm.setFieldOption,
      "input": function($event) {
        _vm.col.summaryConfig.table_id = $event
      }
    }
  }, _vm._l((_vm.tables), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name + item.title,
        "value": item.id
      }
    }, [_c('span', [_vm._v(_vm._s(item.name) + "（" + _vm._s(item.title) + "）")])])
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "关联字段"
    }
  }, [_c('el-select', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.summaryLoading),
      expression: "summaryLoading"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.col.summaryConfig.relate_field_id),
      expression: "col.summaryConfig.relate_field_id"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "请选择关联字段"
    },
    domProps: {
      "value": (_vm.col.summaryConfig.relate_field_id)
    },
    on: {
      "input": function($event) {
        _vm.col.summaryConfig.relate_field_id = $event
      }
    }
  }, _vm._l((_vm.col.summaryConfig.field_option), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.field + item.title,
        "value": item.field_id
      }
    }, [_c('span', [_vm._v(_vm._s(item.field) + "（" + _vm._s(item.title) + "）")])])
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "本表字段"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.summaryConfig.marjor_field_id),
      expression: "col.summaryConfig.marjor_field_id"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "请选择本表字段"
    },
    domProps: {
      "value": (_vm.col.summaryConfig.marjor_field_id)
    },
    on: {
      "change": _vm.summaryFieldChange,
      "input": function($event) {
        _vm.col.summaryConfig.marjor_field_id = $event
      }
    }
  }, _vm._l((_vm.fieldsWithSubform), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.field + item.title,
        "value": item.field_id
      }
    }, [_c('span', [_vm._v(_vm._s(item.field) + "（" + _vm._s(item.title) + "）")])])
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "汇总字段"
    }
  }, [_c('el-select', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.summaryLoading),
      expression: "summaryLoading"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.col.summaryConfig.summary_field_id),
      expression: "col.summaryConfig.summary_field_id"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "请选择汇总字段"
    },
    domProps: {
      "value": (_vm.col.summaryConfig.summary_field_id)
    },
    on: {
      "input": function($event) {
        _vm.col.summaryConfig.summary_field_id = $event
      }
    }
  }, _vm._l((_vm.col.summaryConfig.field_option), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.field + item.title,
        "value": item.field_id
      }
    }, [_c('span', [_vm._v(_vm._s(item.field) + "（" + _vm._s(item.title) + "）")])])
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "搜索条件"
    }
  }, [_c('div', {
    staticClass: "form-tips lh-20"
  }, [_vm._v("变量公式说明：Y代表年，M代表月，D代表天，h代表时，m代表分，s代表秒，+1代表往前加一个单位，-1代表往后减一个单位，支持小数；可使用&进行多公式连接。例：D+1代表明天，M+1代表下个月，h+1代表一个小时后，m+10代表十分钟后，s+30代表30秒后")]), _vm._v(" "), _vm._l((_vm.col.summaryConfig.summary_condition), function(item, index) {
    return _c('div', {
      staticClass: "m-b-10"
    }, [_c('el-select', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.summaryLoading),
        expression: "summaryLoading"
      }, {
        name: "model",
        rawName: "v-model",
        value: (item.field_id),
        expression: "item.field_id"
      }],
      staticClass: "w-120",
      attrs: {
        "placeholder": "汇总字段"
      },
      domProps: {
        "value": (item.field_id)
      },
      on: {
        "input": function($event) {
          item.field_id = $event
        }
      }
    }, _vm._l((_vm.col.summaryConfig.field_option), function(item) {
      return _c('el-option', {
        attrs: {
          "label": item.field,
          "value": item.field_id
        }
      })
    })), _vm._v(" "), _c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.logic),
        expression: "item.logic"
      }],
      staticClass: "w-80",
      attrs: {
        "placeholder": "逻辑"
      },
      domProps: {
        "value": (item.logic)
      },
      on: {
        "input": function($event) {
          item.logic = $event
        }
      }
    }, _vm._l((_vm.logicTypes), function(option) {
      return _c('el-option', {
        attrs: {
          "label": option.name,
          "value": option.id
        }
      })
    })), _vm._v(" "), _c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.type),
        expression: "item.type"
      }],
      staticClass: "w-80",
      attrs: {
        "placeholder": "类型"
      },
      domProps: {
        "value": (item.type)
      },
      on: {
        "input": function($event) {
          item.type = $event
        }
      }
    }, _vm._l((_vm.typeOptions), function(option) {
      return _c('el-option', {
        attrs: {
          "label": option.name,
          "value": option.id
        }
      })
    })), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.value),
        expression: "item.value"
      }],
      staticClass: "w-80",
      domProps: {
        "value": (item.value)
      },
      on: {
        "input": function($event) {
          item.value = $event
        }
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.deleteSummaryCondition(index)
        }
      }
    }, [_vm._v("删除")])])
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSummaryCondition
    }
  }, [_vm._v("添加")])], true)]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), (_vm.isStatistics) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "统计方法"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.statistics_configs.statistics_method),
      expression: "col.statistics_configs.statistics_method"
    }],
    domProps: {
      "value": (_vm.col.statistics_configs.statistics_method)
    },
    on: {
      "input": function($event) {
        _vm.col.statistics_configs.statistics_method = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "10"
    }
  }, [_vm._v("求和")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "20"
    }
  }, [_vm._v("求总数")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "30"
    }
  }, [_vm._v("求平均")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "关联表"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.statistics_configs.table_id),
      expression: "col.statistics_configs.table_id"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "请选择关联表"
    },
    domProps: {
      "value": (_vm.col.statistics_configs.table_id)
    },
    on: {
      "change": _vm.setFieldOption2,
      "input": function($event) {
        _vm.col.statistics_configs.table_id = $event
      }
    }
  }, _vm._l((_vm.tables), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name + item.title,
        "value": item.id
      }
    }, [_c('span', [_vm._v(_vm._s(item.name) + "（" + _vm._s(item.title) + "）")])])
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "关联字段"
    }
  }, [_c('el-select', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.summaryLoading),
      expression: "summaryLoading"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.col.statistics_configs.relate_field_id),
      expression: "col.statistics_configs.relate_field_id"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "请选择关联字段"
    },
    domProps: {
      "value": (_vm.col.statistics_configs.relate_field_id)
    },
    on: {
      "input": function($event) {
        _vm.col.statistics_configs.relate_field_id = $event
      }
    }
  }, _vm._l((_vm.col.statistics_configs.field_option), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.field + item.title,
        "value": item.field_id
      }
    }, [_c('span', [_vm._v(_vm._s(item.field) + "（" + _vm._s(item.title) + "）")])])
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "本表字段"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.statistics_configs.marjor_field_id),
      expression: "col.statistics_configs.marjor_field_id"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "请选择本表字段"
    },
    domProps: {
      "value": (_vm.col.statistics_configs.marjor_field_id)
    },
    on: {
      "input": function($event) {
        _vm.col.statistics_configs.marjor_field_id = $event
      }
    }
  }, _vm._l((_vm.fields), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.field + item.title,
        "value": item.field_id
      }
    }, [_c('span', [_vm._v(_vm._s(item.field) + "（" + _vm._s(item.title) + "）")])])
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "统计字段"
    }
  }, [_c('el-select', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.summaryLoading),
      expression: "summaryLoading"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.col.statistics_configs.statistics_field_id),
      expression: "col.statistics_configs.statistics_field_id"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "请选择统计字段"
    },
    domProps: {
      "value": (_vm.col.statistics_configs.statistics_field_id)
    },
    on: {
      "input": function($event) {
        _vm.col.statistics_configs.statistics_field_id = $event
      }
    }
  }, _vm._l((_vm.col.statistics_configs.field_option), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.field + item.title,
        "value": item.field_id
      }
    }, [_c('span', [_vm._v(_vm._s(item.field) + "（" + _vm._s(item.title) + "）")])])
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "搜索条件"
    }
  }, [_vm._l((_vm.col.statistics_configs.statistics_condition), function(item, index) {
    return _c('div', {
      staticClass: "m-b-10"
    }, [_c('el-select', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.summaryLoading),
        expression: "summaryLoading"
      }, {
        name: "model",
        rawName: "v-model",
        value: (item.field_id),
        expression: "item.field_id"
      }],
      staticClass: "w-120",
      attrs: {
        "placeholder": "统计字段"
      },
      domProps: {
        "value": (item.field_id)
      },
      on: {
        "input": function($event) {
          item.field_id = $event
        }
      }
    }, _vm._l((_vm.col.statistics_configs.field_option), function(item) {
      return _c('el-option', {
        attrs: {
          "label": item.field,
          "value": item.field_id
        }
      })
    })), _vm._v(" "), _c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.logic),
        expression: "item.logic"
      }],
      staticClass: "w-80",
      attrs: {
        "placeholder": "逻辑"
      },
      domProps: {
        "value": (item.logic)
      },
      on: {
        "input": function($event) {
          item.logic = $event
        }
      }
    }, _vm._l((_vm.logicTypes), function(option) {
      return _c('el-option', {
        attrs: {
          "label": option.name,
          "value": option.id
        }
      })
    })), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.value),
        expression: "item.value"
      }],
      staticClass: "w-80",
      domProps: {
        "value": (item.value)
      },
      on: {
        "input": function($event) {
          item.value = $event
        }
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.deleteStatisticsCondition(index)
        }
      }
    }, [_vm._v("删除")])])
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addStatisticsCondition
    }
  }, [_vm._v("添加")])], true)]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPhp),
      expression: "isPhp"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "运算语句"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.arithmetic),
      expression: "col.arithmetic"
    }],
    attrs: {
      "type": "textarea"
    },
    domProps: {
      "value": (_vm.col.arithmetic)
    },
    on: {
      "input": function($event) {
        _vm.col.arithmetic = $event
      }
    }
  })])]), _vm._v(" "), _vm._v(" "), (_vm.fieldSelect && _vm.col.field_type == 120) ? _c('el-form-item', {
    attrs: {
      "label": "外键配置"
    }
  }, [_c('foreign-config', {
    attrs: {
      "keyData": _vm.col.key_config,
      "keyList": _vm.keyList
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.fieldSelect) ? _c('el-form-item', {
    attrs: {
      "label": "字段名",
      "prop": "field_name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.field_name),
      expression: "col.field_name"
    }],
    staticClass: "w-200",
    domProps: {
      "value": (_vm.col.field_name)
    },
    on: {
      "input": function($event) {
        _vm.col.field_name = $event
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.fieldSelect) ? _c('el-form-item', {
    attrs: {
      "label": "显示名",
      "prop": "show_name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.show_name),
      expression: "col.show_name"
    }],
    staticClass: "w-200",
    domProps: {
      "value": (_vm.col.show_name)
    },
    on: {
      "input": function($event) {
        _vm.col.show_name = $event
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isSimple) ? _c('el-form-item', {
    attrs: {
      "label": "是否链接"
    }
  }, [_c('el-checkbox-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.deal_type),
      expression: "col.deal_type"
    }],
    domProps: {
      "value": (_vm.col.deal_type)
    },
    on: {
      "input": function($event) {
        _vm.col.deal_type = $event
      }
    }
  }, _vm._l((_vm.dealTypes), function(item) {
    return _c('el-checkbox', {
      attrs: {
        "true-label": item.id,
        "false-label": 0
      }
    }, [_vm._v(_vm._s(item.name))])
  }))]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._l((_vm.col.link_option), function(option, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showLinkConfig),
        expression: "showLinkConfig"
      }]
    }, [_c('el-form-item', {
      attrs: {
        "label": "参数"
      }
    }, [_c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.param),
        expression: "option.param"
      }],
      attrs: {
        "placeholder": "请选择字段"
      },
      domProps: {
        "value": (option.param)
      },
      on: {
        "input": function($event) {
          option.param = $event
        }
      }
    }, _vm._l((_vm.fields), function(item) {
      return _c('el-option', {
        attrs: {
          "label": item.field,
          "value": item.field
        }
      }, [_c('span', [_vm._v(_vm._s(item.field) + "（" + _vm._s(item.title) + "）")])])
    }))]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "实例"
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.reality.name),
        expression: "option.reality.name"
      }],
      staticClass: "w-180",
      attrs: {
        "disabled": true
      },
      domProps: {
        "value": (option.reality.name)
      },
      on: {
        "change": function($event) {
          _vm.realityChange(option)
        },
        "input": function($event) {
          option.reality.name = $event
        }
      }
    }), _vm._v(" "), _c('el-button', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openRealityDialog(index)
        }
      }
    }, [_vm._v("查找实例")])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "关联字段"
      }
    }, [_c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.fields),
        expression: "option.fields"
      }, {
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      staticClass: "w-300",
      attrs: {
        "filterable": "",
        "multiple": "",
        "placeholder": "请选择"
      },
      domProps: {
        "value": (option.fields)
      },
      on: {
        "input": function($event) {
          option.fields = $event
        }
      }
    }, _vm._l((option.field_option), function(item) {
      return _c('el-option', {
        attrs: {
          "label": item.field + item.title,
          "value": item.field
        }
      }, [_c('span', [_vm._v(_vm._s(item.field) + "（" + _vm._s(item.title) + "）")])])
    }))]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.col.deal_type == _vm.LINK_SENDPARAMS),
        expression: "col.deal_type == LINK_SENDPARAMS"
      }],
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.deleteLinkOption(index)
        }
      }
    }, [_vm._v("删除")])])])
  }), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.col.deal_type == _vm.LINK_DOWNLOAD),
      expression: "col.deal_type == LINK_DOWNLOAD"
    }],
    attrs: {
      "label": "选择下载链接字段"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.download_link),
      expression: "col.download_link"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "请选择字段"
    },
    domProps: {
      "value": (_vm.col.download_link)
    },
    on: {
      "input": function($event) {
        _vm.col.download_link = $event
      }
    }
  }, _vm._l((_vm.fields), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.field + item.title,
        "value": item.field
      }
    }, [_c('span', [_vm._v(_vm._s(item.field) + "（" + _vm._s(item.title) + "）")])])
  }))]), _vm._v(" "), _vm._v(" "), _vm._v(" "), (!_vm.isSimple) ? _c('el-form-item', {
    attrs: {
      "label": "绑定权限规则"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.col.rule.name),
      expression: "col.rule.name"
    }],
    staticClass: "w-180",
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": (_vm.col.rule.name)
    },
    on: {
      "input": function($event) {
        _vm.col.rule.name = $event
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openRuleDialog()
      }
    }
  }, [_vm._v("查找")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.clearRule()
      }
    }
  }, [_vm._v("清空")])]) : _vm._e(), _vm._v(" "), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.col.deal_type == _vm.LINK_SENDPARAMS),
      expression: "col.deal_type == LINK_SENDPARAMS"
    }],
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.addLinkOption
    }
  }, [_vm._v("添加链接配置")])])], true), _vm._v(" "), _c('rule-list', {
    ref: "ruleList",
    on: {
      "selectRule": _vm.selectRule
    }
  }), _vm._v(" "), _c('reality-list', {
    ref: "realityList",
    attrs: {
      "title": _vm.title
    },
    on: {
      "selectReality": _vm.selectReality
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77d94cb0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/classify/colConfig.vue
// module id = 1931
// module chunks = 2